import { Layout } from "components/Layout";

export default function ProjectsRootPage() {
  return (
    <Layout>
      <h1>ProjectsRootPage</h1>
    </Layout>
  );
}
